import { Component, inject, output, signal } from '@angular/core';
import { SettingDao } from '../../core/models/settings/setting-dao.model';
import { UserSettingService } from '../../core/services/user-setting-service';

@Component({
  selector: 'bpw-pagination',
  standalone: true,
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  readonly selectedPageChanged = output<{ begin: number; end: number }>();

  readonly itemsCount = signal(0);
  readonly currentPage = signal(1);
  readonly totalPagesCount = signal(0);
  readonly pageNumbers = signal<number[]>([]);

  readonly pageRangeDisplay = 3;
  readonly itemsPerPage: number;

  private readonly _userSettingService = inject(UserSettingService);

  constructor() {
    this.itemsPerPage = (this._userSettingService.settings as SettingDao)?.generalSettings?.paginationSize ?? 10;
  }

  public clear() {
    this.itemsCount.set(0);
    this.currentPage.set(1);
    this.totalPagesCount.set(0);
    this.pageNumbers.set([]);
  }

  public updateTotalItemCount(itemsCount: number) {
    this.itemsCount.set(itemsCount);
    this.currentPage.set(1);
    const total = Math.ceil(itemsCount / this.itemsPerPage);
    this.totalPagesCount.set(total);
    this.pageNumbers.set(
      Array(total)
        .fill(1)
        .map((_, i) => i + 1),
    );
    this.updateSelectedPage();
  }

  setPage(page: number) {
    this.currentPage.set(page);
    this.updateSelectedPage();
  }

  private updateSelectedPage() {
    const begin = (this.currentPage() - 1) * this.itemsPerPage;
    const end = begin + this.itemsPerPage;
    this.selectedPageChanged.emit({ begin, end });
  }
}
